import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreCardComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params , RouterModule } from '@angular/router';
import { PolicyDataService } from '../../../../../_services/data-services/policy-data.service';
import { BillingDiscountService } from '@services/data-services/billing-discount.service';
import { StorageServiceObservablesService } from '@services/storage-service-observables/storage-service-observables.service';
import { EmailService } from '@services/email/email.service';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, MapfreCardComponent, MapfreButtonComponent],
    selector: 'app-billing-discount-success',
    templateUrl: './billing-discount-success.component.html',
    styleUrls: ['./billing-discount-success.component.scss']
})
export class BillingDiscountSuccessComponent implements OnInit {
    loading: boolean;
    policy: any;
    discountName: string;
    emailAddress: string;
    isAcmic:boolean;
    constructor(
        private activatedRoute: ActivatedRoute,
        private policyDataService: PolicyDataService,
        private billingDiscountService: BillingDiscountService,
        private emailService: EmailService,
        private storageService: StorageServiceObservablesService,
        private acmicService:AcmicService
    ) { }

    ngOnInit(): void {
        this.isAcmic=this.acmicService.isACMIC();
        this.loading = true;
        this.emailAddress = this.storageService.getUserFromStorage();
        this.billingDiscountService.getDiscountName().subscribe(discount => {
            this.discountName = discount;
        })
        this.activatedRoute.params.subscribe((params: Params) => {
            const policyId = params['policyid'];
            this.policyDataService.$policyDetails.subscribe((policyResponse) => {
                if (policyResponse) {
                    this.policy = policyResponse
                        .find(policyDetails => policyDetails.policynumber.policyNumber === policyId);
                    this.loading = false;
                }
            });
        });

    }
}